import { NavLink } from "react-router-dom";
import { ReactComponent as RedDotAlert } from "../../../../src/assets/icons/red_dot_alert.svg";
import CommonTooltip from "../../common/Tooltip";
import { useDispatch, useSelector } from "react-redux";
import { setActiveTab } from "../../../store/activeTabSlice";
import { useEffect } from "react";

export const SidebarLinkGroup = ({ links, collapsed }) => {
  const dispatch = useDispatch();
    const activeTab = useSelector((state) => state.activeTab.activeTab);
    useEffect(()=>{
      if(!activeTab){
        dispatch(setActiveTab("Dashboard"));
      }
    },[activeTab])

  const handleSave = (name) => {
    dispatch(setActiveTab(name));
  };
  return (
    <>
      {links.map(({ name, Icon, link, alert, newTab }) => {
        return (
          <>
            {/* 🔥 Add HR before Help & Support */}
            {(name === "Help & Support" || name === "Knowledge Hub") && (
              <hr className="border-t border-[#143A4F] my-3" />
            )}

            {newTab ? (
              <a
                key={name}
                href={link}
                target="_blank"
                onClick={()=>handleSave(name)}
                rel="noopener noreferrer"
                className="flex items-center justify-center md:justify-between text-[13px] my-1 p-2 font-bold text-[#EAA03D] bg-transparent"
              >
                <div className="flex items-center gap-2">
                  <CommonTooltip id={'itemName'} content={collapsed ? name : ''}>
                    <Icon className={`${collapsed ? "h-4 w-4" : "h-6 w-6"}`} />
                  </CommonTooltip>
                  {!collapsed && <span>{name}</span>}
                </div>
                {alert && !collapsed && <RedDotAlert className="h-3 w-3" />}
              </a>
            ) : (
              <NavLink
                key={name}
                to={link}
                onClick={()=>handleSave(name)}
                className={({ isActive }) =>
                  `flex items-center justify-center md:justify-between text-[13px] my-1 p-2 ${(name === "GPTHub" || name === "Knowledge Hubs")
                    ? "text-[#EAA03D] font-bold"
                    : "text-white font-light"
                  } ${(name !== "GPTHub" || name !== "Knowledge Hubs") &&
                  (isActive ? "bg-[#FB512D] rounded" : "bg-transparent")
                  }`
                }
                end
              >
                <div className="flex items-center gap-2">
                  <CommonTooltip id={"itemName"} content={collapsed ? name : ''}>
                    <Icon className={`${collapsed ? "h-4 w-4" : "h-6 w-6"}`} />
                  </CommonTooltip>
                  {!collapsed && <span>{name}</span>}
                </div>
                {alert && !collapsed && <RedDotAlert className="h-3 w-3" />}
              </NavLink>
            )}
          </>
        );
      })}
    </>
  );
};

